import React from "react";

const ActivityItem = ({ activity, onDelete }) => {
  return (
    <div
      className={`activity-item border p-4 rounded-lg shadow-md transition-transform transform hover:scale-105 dark:bg-gray-800 bg-white text-white`}
    >
      {/* Hiển thị tên */}
      <div className="w-full flex justify-center">
        {activity.listFiles && activity.listFiles.length > 0 && (
          <div className="mx-2">
            <div className="grid grid-cols-2 gap-2 mb-2">
              {activity.listFiles.map((file, index) => (
                <div key={file.id} className="relative w-full overflow-hidden">
                  <img
                    src={file.fullLinkFile}
                    alt={`Activity ${index + 1}`}
                    className="max-w-[300px] max-h-[500px] object-cover transition-transform duration-300 hover:scale-110 rounded-lg"
                  />
                </div>
              ))}
            </div>
          </div>
        )}
      </div>
      {/* Hiển thị trạng thái và thông tin */}
      <div className="mt-2 flex flex-col items-center dark:text-gray-300 text-[#333]">
        <div className="mb-4">
          <p className="">
            Khách hàng {activity?.creatorInfo?.code} {activity?.creatorInfo?.firstName} {activity?.creatorInfo?.lastName} Đã đăng tại{" "}
            <b className="text-blue-400">
              {activity.foundation === "Other"
                ? "nền tảng khác"
                : activity.foundation}
            </b>{" "}
            ngày: {new Date(activity.createdAt).toLocaleDateString()}
          </p>
        </div>
        {activity.linkResult && (
          <p className="text-blue-400 mt-1">
            Mã bài đăng: <b>{activity.linkResult}</b>
          </p>
        )}
        <span className={`status-badge ${getStatusClass(activity.status)}`}>
          {getStatusText(activity.status)}
        </span>
        {activity.status === 2 && activity.reasonNoneValid && (
          <div>
            <p className="text-red-300">
              Lý do từ chối: {activity.reasonNoneValid}
            </p>
          </div>
        )}
      </div>
      {/* <div className="mt-1 flex justify-center">
        {activity.status === 0 && (
          <button
            onClick={() => onDelete(activity.id, "delete")}
            className="text-red-500 hover:text-red-700 transition duration-200"
          >
            Xóa
          </button>
        )}
      </div> */}
    </div>
  );
};

// Helper function to get status text based on status code
const getStatusText = (status) => {
  switch (status) {
    case 0:
      return "Chờ duyệt";
    case 1:
      return "Đã duyệt";
    case 2:
      return "Đã từ chối";
    case 3:
      return "Đã hủy";
    default:
      return "Trạng thái lỗi";
  }
};

// Helper function to get status class for styling
const getStatusClass = (status) => {
  switch (status) {
    case 0:
      return "bg-yellow-600 text-yellow-200 px-2 py-1 rounded cursor-pointer"; // Pending
    case 1:
      return "bg-green-600 text-green-200 px-2 py-1 rounded cursor-pointer"; // Approved
    case 2:
      return "bg-red-600 text-red-200 px-2 py-1 rounded cursor-pointer"; // Rejected
    case 3:
      return "bg-gray-600 text-gray-200 px-2 py-1 rounded cursor-pointer"; // Cancelled
    default:
      return "";
  }
};

export default ActivityItem;
